import React from 'react';
import PropTypes from 'prop-types';
import { transformPrompt } from '../../../../../../utils';

export default function Labels({ labels, minWidth, minAnswerWidth }) {
  const { length } = labels;
  return (
    <div className="bipolar-horizontal-labels" style={{ minWidth }}>
      {labels.map((label, index) => {
        let textAlign = 'bipolar-horizontal-label--center';
        if (index === 0 && length > 1) {
          textAlign = 'bipolar-horizontal-label--left';
        }
        if (index === length - 1 && length > 1) {
          textAlign = 'bipolar-horizontal-label--right';
        }

        return (
          <span
            key={label}
            className={`bipolar-horizontal-label inline-children ${textAlign}`}
            style={{
              minWidth: `${minAnswerWidth}px`,
              maxWidth: `${100 / labels.length}%`,
            }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: transformPrompt(label) || '' }}
          />
        );
      })}
    </div>
  );
}

Labels.propTypes = {
  labels: PropTypes.array,
  minWidth: PropTypes.number,
  minAnswerWidth: PropTypes.number,
};
